export default function IosPulse() {
  return (
    <div
      className="ion-icon-ios-pulse"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<path d="M448,288c-15.268,0-28.029,10.695-31.223,25h-59.004l-30.181-90.896c-1.105-3.329-4.246-5.543-7.759-5.478
	c-3.508,0.072-6.559,2.422-7.524,5.795L258.067,411.74L199.892,62.685c-0.624-3.74-3.787-6.528-7.576-6.679
	c-3.809-0.139-7.161,2.382-8.078,6.061L121.748,313H32v16h96c3.674,0,6.875-2.502,7.763-6.066l54.685-219.591l57.661,345.973
	c0.615,3.688,3.703,6.459,7.437,6.672c0.153,0.009,0.307,0.013,0.459,0.013c3.549,0,6.699-2.35,7.687-5.797l56.872-198.496
	l23.845,71.813c1.087,3.271,4.146,5.479,7.593,5.479h65.292c3.89,13.289,16.161,23,30.708,23c17.674,0,32-14.327,32-32
	S465.674,288,448,288z"/>
</svg>
`,
      }}
    />
  )
}
